export default {

    // Main pages
    HOME: '/',
    FORSLAG: '/forslag/',
    BEDSTE: '/bedste/'
};